import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for Capacitor apps
 */
export const Platform = {
  /** Check if running in a native app (iOS or Android) */
  isNative: Capacitor.isNativePlatform(),
  
  /** Check if running on iOS */
  isIOS: Capacitor.getPlatform() === 'ios',
  
  /** Check if running on Android */
  isAndroid: Capacitor.getPlatform() === 'android',
  
  /** Check if running in web browser */
  isWeb: !Capacitor.isNativePlatform(),
  
  /** Get current platform name */
  getPlatform: () => Capacitor.getPlatform(),
  
  /** Check if running in native app (alias for isNative) */
  isApp: () => Capacitor.isNativePlatform(),
  
  /**
   * Get safe area insets for iOS
   * Use these in CSS for notch/home indicator handling
   */
  getSafeAreaInsets: () => {
    if (Platform.isIOS) {
      return {
        top: 'env(safe-area-inset-top)',
        bottom: 'env(safe-area-inset-bottom)',
        left: 'env(safe-area-inset-left)',
        right: 'env(safe-area-inset-right)'
      };
    }
    return { top: '0px', bottom: '0px', left: '0px', right: '0px' };
  }
};
